import { createApp } from 'vue'

import UserForm from '@/src/javascripts/settings/users/UserForm.vue'
import BaseAlert from '@/src/vueComponent/BaseAlert.vue'

$(document).on('turbo:load turbo:render', () => {
  const userForm = document.querySelector('#user-form')
  if (userForm && !userForm.__vue_app__) {
    createApp({ components: { UserForm, BaseAlert } }).mount(userForm)
  }
})
